<template>
  <div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class=" inpBox">
               <el-form-item label="企业名称:" prop="companyName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.companyName"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:" prop="zzauditStatus">
                <el-select v-model="searchFrom.zzauditStatus" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in zzauditStatusOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="三证合一:" prop="bsnsOneness ">
                <el-select v-model="searchFrom.bsnsOneness " placeholder="请选择">
                  <el-option
                    v-for="(item,index) in bsnsOnenessOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册人:" prop="legalPerson" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.legalPerson "></el-input>
              </el-form-item>
              <el-form-item label="申请时间:" prop="dateTime" >
                <el-date-picker
                  v-model="searchFrom.dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="营业执照号:" prop="bsnsLicenseno" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.bsnsLicenseno "></el-input>
              </el-form-item>
              <div style="margin:10px 0 0 60px;">
              <el-form-item >
                <el-button type="primary"  @click="feeChaXun" btnCode="000P00UB001" v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="chongZhi" btnCode="000P00UB002" v-if="btnFlg[1]">重置</el-button>
              </el-form-item>
              </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        @row-click="dianjixuanzhong"
        :row-style="{height:'35px'}"
        @selection-change="selectGoods"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="180">
          <template slot-scope="scope">
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <div>
            <el-button type="text" size="small" @click="passClick(scope.row)" btnCode="000P00UB003" v-if="scope.row.zzauditStatus == '1' && btnFlg[2]">通过</el-button>
            <el-button type="text" size="small" @click="recordClick(scope.row)" btnCode="000P00UB005" v-if="scope.row.zzauditStatus != '1'  && btnFlg[4]">记录</el-button>
            <el-button type="text" size="small" @click="rejectClick(scope.row)" btnCode="000P00UB004" v-if="scope.row.zzauditStatus == '1' && btnFlg[3]">驳回</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="zzauditStatusShow"   label="审核状态" align="center"  ></el-table-column>
        <el-table-column prop="companyName"    label="企业名称"  align="center" width="270" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bsnsOnenessShow"    label="三证合一"  align="center"  width="100"></el-table-column>
        <el-table-column property="bsnsLicenseno" label="营业执照号"  align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column property="transPermitno" label="道路运输经营许可证号"  align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson"    label="注册人" align="center"  width="120"></el-table-column>
        <el-table-column prop="legalPersonId"  label="注册人身份证号" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="personidValidity"  label="身份证有效期" align="center" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="ext1"  label="注册电话" align="center" width="120"></el-table-column>
        <el-table-column prop="contractName"  label="联系人" align="center" width="120"></el-table-column>
        <el-table-column prop="contractPhone"  label="联系电话" align="center" width="120"></el-table-column>
        <!-- <el-table-column prop="lastauditUser"  label="审核人" align="center" width="120"></el-table-column> -->
        <el-table-column prop="lastapplyTime"  label="申请时间" align="center" width="200" :formatter="dateFormat2"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: right;">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>证件扫描件</h4>
    </div>
    <div class="addressBox">
        <div>
        <ul class="ul">
          <li  v-for="(item,index) in srcList"  :key="index">
            <el-image
              fit="cover"
              style="width: 150px; height: 150px"
              :src="item"
              :preview-src-list="getSrcList(index)"
            >
            </el-image>
          </li>
          <!-- <li v-if="legalPersonpic1 != ''">
            <img :src="legalPersonpic1" preview="1">
          </li>
          <li v-if="legalPersonpic2 != ''">
            <img :src="legalPersonpic2" preview="2">
          </li>
          <li v-if="transPermitpic1 != ''">
            <img :src="transPermitpic1" preview="3">
          </li>
          <li v-if="bsnsLicensepic != ''  && bsnsOneness == '0'">
            <img :src="bsnsLicensepic" preview="4">
          </li>
          <li v-if="businessLicensepic != ''  && bsnsOneness == '1'">
            <img :src="businessLicensepic" preview="5">
          </li>
          <li v-if="taxRegistrapic != ''  && bsnsOneness == '1'">
            <img :src="taxRegistrapic" preview="6">
          </li>
           <li v-if="taxOrgcodepic != ''  && bsnsOneness == '1'">
            <img :src="taxOrgcodepic" preview="7">
          </li> -->
        </ul>
        <ul class="ul2">
          <li v-if="legalPersonpic1 != ''">法人身份证（正面）</li>
          <li v-if="legalPersonpic2 != ''">法人身份证（背面）</li>
          <li v-if="transPermitpic1 != ''">道路运输证</li>
          <li v-if="bsnsLicensepic != '' && bsnsOneness == '0'">营业执照（三证合一）</li>
          <li v-if="businessLicensepic != ''  && bsnsOneness == '1'">营业执照（非三证合一）</li>
          <li v-if="taxRegistrapic != ''  && bsnsOneness == '1'">税务登记证（非三证合一）</li>
          <li v-if="taxOrgcodepic != ''  && bsnsOneness == '1'">织机构代码（非三证合一）</li>
        </ul>
      </div>
    </div>
    <!--点击记录-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.ext1}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{activity.ext2}}</p>
            <p v-if="activity.auditResult">审核结果：{{activity.auditResult}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!--点击驳回-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="rejectmark"
    width="550px"
    center>
      <span>
        <el-form
          :model="rejectFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          ref="rejectFrom"
          class="demo-form-inline"
          label-width="110px" size="mini">
        <div class="addinpBox" >
            <el-form-item label="驳回原因:" prop="reason" style="margin-top:10px;">
              <el-input type="textarea" v-model="rejectFrom.reason" onkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
            </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="rejectSubmit('rejectFrom')" :loading="rejectLoadding">确定</el-button>
        <el-button @click="rejectClose('rejectFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  customerCheckList, // 列表查询
  dictionary, // 数据字典
  auditingStatus, // 驳回/通过
  zzauditHistory // 记录
} from '@/api/consignment'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00UB001', '000P00UB002', '000P00UB003',
        '000P00UB004', '000P00UB005'],
      title: '',
      h: '500px',
      // detailsH: '200px',
      total: 0,
      srcList: [],
      searchFrom: {
        companyName: '',
        zzauditStatus: '1',
        bsnsLicenseno: '',
        bsnsOneness: '',
        legalPerson: '',
        pageNo: 1,
        pageSize: 10,
        dateTime: [],
        startTime: '',
        endTime: ''
      },
      // 驳回
      rejectFrom: {
        reason: '' // 驳回原因
      },
      rules: {
        reason: [
          { required: true, message: '驳回原因不能为空', trigger: ['blur', 'change'] }
        ]
      },
      // 记录
      activities: [],
      rejectId: '', // 驳回id
      rejectStatus: '',
      rejectLoadding: false,
      isAddImgZ: '',
      isAddImg1: '',
      isAddImg2: '',
      paramsZ: [],
      params1: [],
      params2: [],
      zzauditStatusOptions: [], // 审核状态
      bsnsOnenessOptions: [{
        value: '0',
        label: '是'
      }, {
        value: '1',
        label: '否'
      }],
      recordMark: false, // 记录弹窗
      rejectmark: false, // 驳回弹窗
      addSpuLoading: false,
      value: '',
      tableList: [],
      addSpuBtn: false,
      addShuXingShow: false, // 新增属性保存按钮
      addSpuShuXingMark: false,
      xuanzhongArr: [],
      currentXQ: '',
      spuId: '',
      legalPersonpic1: '',
      legalPersonpic2: '',
      transPermitpic1: '',
      businessLicensepic: '',
      taxRegistrapic: '',
      taxOrgcodepic: '',
      bsnsLicensepic: '',
      bsnsOneness: '',
      tabLoading: false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    // let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.5 * pH - h - 30 + 'px'
    // this.detailsH = 0.5 * pH - h2 - 70 + 'px'
  },
  created () {
    this.dictionary()
    this.getListData()
    this.btnFlg = getBtn(this.btnIdArr, '/registerAttestation/fleetCheck')
  },
  methods: {
    // 获取审核状态下拉框数据
    dictionary () {
      dictionary({
        groupNo: 'zzaudit_status'
      }).then(res => {
        this.zzauditStatusOptions = res.zzaudit_status
        this.zzauditStatusOptions.forEach((item, index) => {
          if (item.itemNo == '1') {
            this.searchFrom.zzauditStatus = item.itemNo
          }
        })
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {

      })
    },
    // 查询接口
    getListData () {
      let startTime = ''
      let endTime = ''
      if (this.searchFrom.dateTime.length != '0') {
        startTime = this.searchFrom.dateTime[0]
        endTime = this.searchFrom.dateTime[1]
      }
      this.tabLoading = true
      customerCheckList({
        businessFlg: 2, // 客户审核1，车队审核2
        companyName: this.searchFrom.companyName,
        zzauditStatus: this.searchFrom.zzauditStatus,
        bsnsLicenseno: this.searchFrom.bsnsLicenseno,
        bsnsOneness: this.searchFrom.bsnsOneness,
        legalPerson: this.searchFrom.legalPerson,
        pageNo: this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize,
        startTime: startTime,
        endTime: endTime
      }).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
        this.$previewRefresh()
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        this.tabLoading = false
        DonMessage.error(err.message)
      })
    },
    // 点击查询
    feeChaXun () {
      this.getListData()
    },
    // 点击重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        companyName: '',
        zzauditStatus: '',
        bsnsLicenseno: '',
        bsnsOneness: '',
        legalPerson: '',
        dateTime: []
      }
      this.getListData()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getListData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getListData()
    },
    // 点击记录
    recordClick (row) {
      this.title = '记录'
      this.recordMark = true
      zzauditHistory({
        id: row.id
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 通过
    passClick (row) {
      this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          this.tabLoading = true
          auditingStatus({
            // 驳回传3  通过传2
            id: row.id,
            zzauditStatus: '2'
          })
            .then(res => {
              this.tabLoading = false
              DonMessage.success('操作成功!')
              this.getListData()
            })
            .catch(err => {
              this.tabLoading = false
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
    },
    // 点击驳回
    rejectClick (row) {
      this.rejectFrom.reason = ''
      this.title = '驳回'
      this.rejectmark = true
      this.rejectId = row.id
      this.rejectStatus = row.zzauditStatus
    },
    // 驳回确定
    rejectSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rejectFrom.reason === '' || this.rejectFrom.reason == ' ') {
            DonMessage.error('驳回原因不能为空')
          } else {
            this.rejectLoadding = true
            auditingStatus({
              // 驳回传3  通过传2
              nopassReason: this.rejectFrom.reason,
              id: this.rejectId,
              zzauditStatus: '3'
            })
              .then(res => {
                this.rejectLoadding = false
                DonMessage.success('操作成功!')
                this.rejectmark = false
                this.getListData()
              })
              .catch(err => {
                this.rejectLoadding = false
                DonMessage.error(err.message)
              })
          }
        } else {
          return false
        }
      })
    },
    // 驳回取消
    rejectClose (formName) {
      this.$refs[formName].resetFields()
      this.rejectmark = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.tableList.toggleRowSelection(row)
      this.spuId = row.id
      this.legalPersonpic1 = row.legalPersonpic1
      this.legalPersonpic2 = row.legalPersonpic2
      this.transPermitpic1 = row.transPermitpic1
      this.bsnsLicensepic = row.bsnsLicensepic
      this.businessLicensepic = row.businessLicensepic
      this.taxRegistrapic = row.taxRegistrapic
      this.taxOrgcodepic = row.taxOrgcodepic
      this.bsnsOneness = row.bsnsOneness
      this.srcList = []
      if (this.legalPersonpic1 != '') {
        this.srcList.push(this.legalPersonpic1)
      }
      if (this.legalPersonpic2 != '') {
        this.srcList.push(this.legalPersonpic2)
      }
      if (this.transPermitpic1 != '') {
        this.srcList.push(this.transPermitpic1)
      }
      if (this.bsnsOneness == '0' && this.bsnsLicensepic != '') {
        this.srcList.push(this.bsnsLicensepic)
      }
      if (this.bsnsOneness == '1' && this.businessLicensepic != '') {
        this.srcList.push(this.businessLicensepic)
      }
      if (this.bsnsOneness == '1' && this.taxRegistrapic != '') {
        this.srcList.push(this.taxRegistrapic)
      }
      if (this.bsnsOneness == '1' && this.taxOrgcodepic != '') {
        this.srcList.push(this.taxOrgcodepic)
      }
      this.$previewRefresh()
    },
    // 点击凭证放大
    getSrcList (index) {
      return this.srcList.slice(index).concat(this.srcList.slice(0, index))
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      // var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      // var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      // var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() + '-' + month + '-' + date
        // +
        // ' ' +
        // hour +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    dateFormat2: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -60px;
}
.inpBox .el-date-editor{
    width: 260px!important;
 }
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBox{
  margin-left: 10px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.tiHuoDanGuanLiWarp-body-table {
      margin-top: 5px;
 }
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.box{
      width: 500px;
      display: flex;
      justify-content: space-around;
      flex-wrap:wrap;
      .imgBox{
        display: flex;
        flex-direction: column;
        width: 150px;
        // /deep/.el-upload--picture-card{
        // // width: 180px;
        // // height: 100px;
        // }
        span{
          text-align: center;
        }
      }
      .hidden /deep/.el-upload--picture-card{
        display: none;
      }
      /deep/.el-upload--picture-card {
        background-image: url('../../../../assets/images/upload2.png');
        // background-size:180px 100px;
      }
      // /deep/.el-upload-list--picture-card .el-upload-list__item{
      //   // width: 150px;
      //   // height: 100px;
      // }
    }
    .addressBox{
  .ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>
